import { SlideNavigationType } from "~/components/molecules";

type ReturnType = {
  navigations: SlideNavigationType[];
};

type PropsType = {
  selectedArray: [boolean, boolean];
};

export const useAiCustomizeSlideNavigation = ({
  selectedArray,
}: PropsType): ReturnType => {
  const navigations = [
    {
      label: "会社コンテキスト",
      href: "/managers/ai_costomize/company_contexts",
      selected: selectedArray[0],
    },
    {
      label: "投稿要約",
      href: "/managers/ai_costomize/company_post_summaries",
      selected: selectedArray[1],
    },
  ];

  return {
    navigations,
  };
};
